(function () {
  const copyButtons = document.querySelectorAll('.discount-banner__copy-btn');

  for (const button of copyButtons) {
    button.addEventListener('click', async function () {
      const wrapper = this.closest('.discount-banner__code-wrapper');
      const discountCode = this.dataset.discountCode;
      const buttonText = this.querySelector('.discount-banner__copy-btn-text');

      try {
        await navigator.clipboard.writeText(discountCode);

        wrapper.classList.add('copied');
        buttonText.textContent = 'COPIED';

        setTimeout(() => {
          wrapper.classList.remove('copied');
          buttonText.textContent = 'Copy';
        }, 3000);
      } catch (err) {
        console.error('Failed to copy discount code:', err);
      }
    });
  }
})();
